import React from 'react';
import { Table } from 'antd';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { showModal } from 'Core/redux/main/slice';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner';
import { actions as auxiliaryEquipmentActions } from './store/slice';

const { setAuxiliaryEquipment } = auxiliaryEquipmentActions;

const { AUXILIARY_EQUIPMENT_ADD_EDIT } = MODAL_TYPES;

const AuxiliaryEquipmentTable = ({ activeLane }) => {
  const dispatch = useDispatch();
  const data = useSelector(state => state.auxiliaryEquipment?.data || []);
  const isLoading = useSelector(state => state.auxiliaryEquipment?.loading || false);

  const handleEditClick = record => {
    console.log('Opening modal from table with record:', record);
    console.log('Record ID:', record?.id);
    console.log('Record auxiliaryEquipmentId:', record?.auxiliaryEquipmentId);
    dispatch(setAuxiliaryEquipment(record));
    dispatch(showModal(AUXILIARY_EQUIPMENT_ADD_EDIT, record));
  };

  const handleDeleteClick = id => {
    // dispatch(deleteAuxiliaryEquipment(id));
  };

  const handleCheckboxChange = (e, record) => {};

  // Filter data based on active lane
  const filteredData = activeLane === 'ALL' ? data : data.filter(item => item.lane === activeLane);

  const columns = [
    {
      title: 'Asset Number',
      dataIndex: 'assetNumber',
      sorter: (a, b) => (a.assetNumber || '').length - (b.assetNumber || '').length,
    },
    {
      title: 'Brand',
      dataIndex: 'brand',
      sorter: (a, b) => (a.brand || '').length - (b.brand || '').length,
    },
    {
      title: 'Tonnage',
      dataIndex: 'tonnage',
      sorter: (a, b) => (a.tonnage || '').length - (b.tonnage || '').length,
    },
    {
      title: 'Cell Number',
      dataIndex: 'cellNumber',
      sorter: (a, b) => (a.cellNumber || '').length - (b.cellNumber || '').length,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      render: () => <span className="badge bg-success">Active</span>,
    },
    {
      title: 'Actions',
      dataIndex: 'actions',
      render: (text, record) => (
        <div className="d-flex">
          <Link
            to="#"
            className="btn btn-sm btn-outline-primary me-2"
            onClick={() => handleEditClick(record)}
          >
            Edit
          </Link>
          <Link
            to="#"
            className="btn btn-sm btn-outline-danger"
            onClick={() => handleDeleteClick(record.id)}
          >
            Delete
          </Link>
        </div>
      ),
    },
  ];

  return (
    <div className="table-responsive">
      {isLoading && <LoadingSpinner />}
      <Table
        columns={columns}
        dataSource={filteredData}
        rowKey="id"
        pagination={{ pageSize: 10 }}
        size="small"
      />
    </div>
  );
};

export default AuxiliaryEquipmentTable;
